import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  className = '',
  disabled,
  ...props
}, ref) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-[#344054] mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#667085]">
            {leftIcon}
          </div>
        )}
        <input
          ref={ref}
          className={`
            w-full bg-white border rounded-lg transition-colors
            ${error ? 'border-red-500' : 'border-[#D0D5DD]'}
            ${disabled ? 'bg-[#F9FAFB] cursor-not-allowed' : ''}
            ${leftIcon ? 'pl-10' : 'pl-3.5'} 
            ${rightIcon ? 'pr-10' : 'pr-3.5'}
            py-2.5
            focus:outline-none focus:ring-2 focus:ring-[#7F56D9] focus:border-[#7F56D9]
            disabled:opacity-50
          `}
          disabled={disabled}
          {...props}
        />
        {rightIcon && (
          <div className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#667085]">
            {rightIcon}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1 text-sm text-[#667085]">{hint}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';